import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import LayoutAppHeader from '../../../../shared/components/Layout/components/container/LayoutAppHeader';
import TvModeHeader from './TvModeHeader';

import useFeed from '../hooks/useFeed';

const LayoutContainer = styled('div')`
  background-color: #f5f5f5;
  overflow-y: ${(props) => (props.fullWidth ? 'hidden' : 'scroll')};
`;

const MainContent = styled('main')`
  position: relative;
  height: 100%;
  min-height: 100%;
  max-width: 2000px;
  margin: 0 auto;
  padding: ${(props) => (props.fullWidth ? '0px' : '64px 15px 15px 15px')};
  ${(props) => (props.fullWidth ? (
    'overflow: hidden;'
  ) : '')}
  @media screen and (max-width: 640px) {
    padding: ${(props) => (props.fullWidth ? '0px' : '64px 0px 15px 0px')};
  }
`;

const CustomLayout = ({
  children,
  fullWidth,
  isTvMode,
  scrollToTopOfFeed,
}) => {
  const {
    handleFetchMoreFeed,
  } = useFeed();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isEndOfList = useSelector((state) => state.feed.data.isEndOfList);
  const isNextPageLoading = useSelector((state) => state.feed.data.isNextPageLoading);
  const selectedGroups = useSelector((state) => state.feed.data.selectedGroups);
  const searchString = useSelector((state) => state.feed.data.searchString);

  const { userSkin: skin = {} } = currentUser || {};
  const { darkTheme: isPrimaryDarkTheme = false, logo = null } = skin || {};

  const loadMore = () => {
    if (!isEndOfList && !isNextPageLoading && currentUser?.accountCode) {
      handleFetchMoreFeed(currentUser.accountCode, selectedGroups, searchString);
    }
  };

  const scrollRef = useBottomScrollListener(() => loadMore(), { offset: 100 });

  return (
    <LayoutContainer ref={scrollRef} fullWidth={fullWidth}>
      {isTvMode && (
        <TvModeHeader
          logo={logo}
          isPrimaryDarkTheme={isPrimaryDarkTheme}
          scrollToTopOfFeed={scrollToTopOfFeed}
        />
      )}
      <LayoutAppHeader hideHeader={isTvMode} />
      <MainContent
        className={fullWidth || isTvMode ? '' : 'container'}
        fullWidth={fullWidth}
      >
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

CustomLayout.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  isTvMode: PropTypes.bool,
  scrollToTopOfFeed: PropTypes.func.isRequired,
};

CustomLayout.defaultProps = {
  fullWidth: false,
  isTvMode: false,
};

export default CustomLayout;
